import { dropshipPartners } from "@/mocks/dashboardData";

const platformIcon: Record<string, string> = {
  YouTube: "ri-youtube-line",
  TikTok: "ri-tiktok-line",
  Facebook: "ri-facebook-circle-line",
  Instagram: "ri-instagram-line",
  Twitter: "ri-twitter-x-line",
};

const platformColor: Record<string, string> = {
  YouTube: "text-red-500",
  TikTok: "text-gray-800",
  Facebook: "text-amber-600",
  Instagram: "text-pink-500",
  Twitter: "text-gray-700",
};

const DropshippingTab = () => {
  const totalSales = dropshipPartners.reduce((a, p) => a + p.sales, 0);
  const totalCommission = dropshipPartners.reduce((a, p) => a + p.commission, 0);
  const activePartners = dropshipPartners.filter((p) => p.status === "active").length;

  return (
    <div className="space-y-6">
      {/* Summary */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {[
          { icon: "ri-group-line", label: "Active Partners", value: `${activePartners}`, color: "text-amber-600", bg: "bg-amber-50" },
          { icon: "ri-shopping-bag-3-line", label: "Total Dropship Sales", value: `${totalSales}`, color: "text-emerald-600", bg: "bg-emerald-50" },
          { icon: "ri-money-dollar-circle-line", label: "Total Commission Paid", value: `$${totalCommission.toLocaleString()}`, color: "text-amber-600", bg: "bg-amber-50" },
        ].map((s) => (
          <div key={s.label} className="bg-white border border-amber-100 rounded-2xl p-5 flex items-center gap-4">
            <div className={`w-11 h-11 flex items-center justify-center ${s.bg} rounded-xl flex-shrink-0`}>
              <i className={`${s.icon} ${s.color} text-xl`}></i>
            </div>
            <div>
              <div className="font-black text-gray-900 text-2xl leading-none">{s.value}</div>
              <div className="text-gray-400 text-xs mt-0.5">{s.label}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Settings */}
      <div className="bg-white border border-amber-100 rounded-2xl p-5">
        <h4 className="font-black text-gray-900 text-base mb-4 flex items-center gap-2">
          <i className="ri-settings-3-line text-amber-500"></i> Dropshipping Settings
        </h4>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1.5">Commission Rate (%)</label>
            <input defaultValue="20" type="number" className="w-full border border-amber-100 rounded-xl px-3 py-2 text-sm focus:outline-none focus:border-amber-400" />
          </div>
          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1.5">Avg. Shipping Time</label>
            <select className="w-full border border-amber-100 rounded-xl px-3 py-2 text-sm focus:outline-none focus:border-amber-400 bg-white">
              <option>3–7 business days</option>
              <option>7–14 business days</option>
              <option>1–3 business days</option>
            </select>
          </div>
          <div>
            <label className="block text-xs font-semibold text-gray-600 mb-1.5">Private Label</label>
            <select className="w-full border border-amber-100 rounded-xl px-3 py-2 text-sm focus:outline-none focus:border-amber-400 bg-white">
              <option>Yes, available</option>
              <option>No</option>
              <option>On request</option>
            </select>
          </div>
        </div>
        <button className="mt-4 bg-amber-500 hover:bg-amber-600 text-white font-semibold text-sm px-5 py-2 rounded-xl transition-colors cursor-pointer whitespace-nowrap">
          Save Settings
        </button>
      </div>

      {/* Partners */}
      <div>
        <h4 className="font-black text-gray-900 text-base mb-4 flex items-center gap-2">
          <i className="ri-group-line text-amber-500"></i> Dropship Partners
        </h4>
        <div className="space-y-3">
          {dropshipPartners.map((partner) => (
            <div key={partner.id} className="bg-white border border-amber-100 rounded-2xl p-4 flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <div className="w-12 h-12 flex-shrink-0 rounded-full overflow-hidden border border-amber-100">
                <img src={partner.avatar} alt={partner.name} className="w-full h-full object-cover object-top" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <p className="font-bold text-gray-900 text-sm">{partner.name}</p>
                  <span className={`flex items-center gap-1 text-xs font-semibold ${platformColor[partner.platform] || "text-gray-600"}`}>
                    <i className={`${platformIcon[partner.platform] || "ri-global-line"} text-sm`}></i>
                    {partner.platform}
                  </span>
                  <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${partner.status === "active" ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"}`}>
                    {partner.status === "active" ? "Active" : "Pending"}
                  </span>
                </div>
                <p className="text-gray-400 text-xs mt-0.5">{partner.country}</p>
              </div>
              <div className="flex items-center gap-6 text-sm flex-shrink-0">
                <div className="text-center">
                  <div className="font-black text-gray-900">{partner.sales}</div>
                  <div className="text-gray-400 text-xs">Sales</div>
                </div>
                <div className="text-center">
                  <div className="font-black text-emerald-600">${partner.commission.toLocaleString()}</div>
                  <div className="text-gray-400 text-xs">Commission</div>
                </div>
                <button className="w-8 h-8 flex items-center justify-center border border-amber-100 rounded-lg text-amber-600 hover:bg-amber-50 cursor-pointer transition-colors">
                  <i className="ri-message-3-line text-sm"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DropshippingTab;
